import { render, staticRenderFns } from "./CampaignsWidget.vue?vue&type=template&id=6aa7db4c&scoped=true"
import script from "./CampaignsWidget.vue?vue&type=script&lang=js"
export * from "./CampaignsWidget.vue?vue&type=script&lang=js"
import style0 from "./CampaignsWidget.vue?vue&type=style&index=0&id=6aa7db4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7db4c",
  null
  
)

export default component.exports